import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LangProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Admin from "@/components/Admin";
import V2Home from "@/components/v2/V2Home";
import Privacy from "@/components/v2/Privacy";
import Cookie from "@/components/v2/Cookie";
import CondizioniVendita from "@/components/v2/CondizioniVendita";
import FaqPage from "@/components/v2/FaqPage";

const SandboxBadge = () => (
  <div
    data-testid="sandbox-badge"
    className="fixed bottom-4 left-4 z-[90] rounded-full bg-[#1A1B18]/90 backdrop-blur text-white/90 text-[10px] uppercase tracking-[0.2em] px-4 py-2 pointer-events-none"
  >
    Area Test · non pubblica
  </div>
);

const Sandbox = () => (
  <>
    <V2Home sandbox />
    <SandboxBadge />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FAF9F6] text-[#1A1B18]">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<V2Home />} />
            <Route path="/prenota" element={<V2Home />} />
            <Route path="/v2" element={<V2Home />} />
            <Route path="/v1" element={<Sandbox />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<Cookie />} />
            <Route path="/condizioni-di-vendita" element={<CondizioniVendita />} />
            <Route path="/faq" element={<FaqPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LangProvider>
    </div>
  );
}

export default App;
